<template>
  <sub-page title="培训效果评价">
    <div class="evaluate-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">戴义杰</div>
          <div class="user-id">3411**********5619</div>
        </div>
      </div>

      <div class="result-text">共查询到 1 条培训完结记录</div>

      <div class="info-card">
        <div class="info-item"><span class="label">班期名称：</span><span class="value">2021012081</span></div>
        <div class="info-item"><span class="label">培训机构：</span><span class="value">南京智能制造研究院有限公司</span></div>
        <div class="info-item"><span class="label">培训等级：</span><span class="value">合格</span></div>
        <div class="info-item"><span class="label">培训工种：</span><span class="value">岗位培训</span></div>
        <div class="info-item"><span class="label">培训结束时间：</span><span class="value">2021-02-17 00:00:00</span></div>
      </div>

      <!-- 评价区 -->
      <div class="eval-card">
        <div class="eval-title">培训效果评价</div>

        <div class="star-row" v-for="dim in dimensions" :key="dim.key">
          <span class="star-label">{{ dim.name }}</span>
          <span class="stars">
            <svg
              v-for="n in 5"
              :key="n"
              viewBox="0 0 24 24"
              :class="['star', { active: scores[dim.key] >= n }]"
              @click="scores[dim.key] = n"
            ><path d="M12 2 L15 9 L22 9.5 L16.5 14.2 L18.3 21.5 L12 17.6 L5.7 21.5 L7.5 14.2 L2 9.5 L9 9 Z"/></svg>
          </span>
          <span class="star-text">{{ scoreText(scores[dim.key]) }}</span>
        </div>

        <textarea
          v-model="comment"
          class="eval-textarea"
          maxlength="200"
          placeholder="请输入您对本次培训的意见和建议（选填，不超过200字）"
        ></textarea>
        <div class="word-count">{{ comment.length }}/200</div>
      </div>

      <div class="footer-btn">
        <button class="submit-btn" :disabled="submitted" @click="handleSubmit">{{ submitted ? '已提交评价' : '提交评价' }}</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'TrainingEvaluate',
  components: { SubPage },
  data() {
    return {
      dimensions: [
        { key: 'course', name: '课程内容' },
        { key: 'teacher', name: '讲师水平' },
        { key: 'organize', name: '组织管理' },
        { key: 'gain', name: '培训收获' }
      ],
      scores: { course: 5, teacher: 5, organize: 5, gain: 5 },
      comment: '',
      submitted: false
    }
  },
  methods: {
    scoreText(n) {
      return ['', '很不满意', '不满意', '一般', '满意', '非常满意'][n]
    },
    handleSubmit() {
      if (this.submitted) return
      const dims = this.dimensions
      for (const d of dims) {
        if (!this.scores[d.key]) {
          this.$alert(`请对「${d.name}」进行星级评分`)
          return
        }
      }
      this.submitted = true
      this.$alert('培训效果评价提交成功，感谢您的反馈')
    }
  }
}
</script>

<style scoped>
.evaluate-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
  margin-bottom: calc(16 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.result-text {
  font-size: calc(28 * var(--w));
  color: #646566;
  padding: calc(16 * var(--w)) calc(32 * var(--w));
}
.info-card {
  background: #fff;
  margin: 0 calc(24 * var(--w));
  border-radius: calc(12 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.info-item {
  display: flex;
  align-items: center;
  font-size: calc(28 * var(--w));
  line-height: 1.8;
}
.label {
  color: #969799;
  white-space: nowrap;
}
.value {
  color: #323233;
}
.eval-card {
  background: #fff;
  margin: calc(20 * var(--w)) calc(24 * var(--w)) 0;
  border-radius: calc(12 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.eval-title {
  font-size: calc(32 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(16 * var(--w));
}
.star-row {
  display: flex;
  align-items: center;
  padding: calc(14 * var(--w)) 0;
  gap: calc(12 * var(--w));
}
.star-label {
  font-size: calc(28 * var(--w));
  color: #323233;
  width: calc(170 * var(--w));
  flex-shrink: 0;
}
.stars {
  display: flex;
  gap: calc(8 * var(--w));
}
.star {
  width: calc(44 * var(--w));
  height: calc(44 * var(--w));
  fill: #dcdee0;
  cursor: pointer;
}
.star.active {
  fill: #FFB400;
}
.star-text {
  font-size: calc(24 * var(--w));
  color: #ff976a;
  margin-left: calc(8 * var(--w));
}
.eval-textarea {
  width: 100%;
  box-sizing: border-box;
  height: calc(200 * var(--w));
  margin-top: calc(20 * var(--w));
  background: #f7f8fa;
  border: 1px solid #ebedf0;
  border-radius: calc(8 * var(--w));
  padding: calc(20 * var(--w));
  font-size: calc(28 * var(--w));
  color: #323233;
  outline: none;
  resize: none;
}
.word-count {
  text-align: right;
  font-size: calc(24 * var(--w));
  color: #c8c9cc;
  margin-top: calc(8 * var(--w));
}
.footer-btn {
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.submit-btn:disabled {
  background: #c8c9cc;
}
</style>



// WEBPACK FOOTER //
// src/pages/TrainingEvaluate.vue